import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

export enum CTALayout {
  Left = 'left',
  Center = 'center',
}

const CTALayoutSchema = z.nativeEnum(CTALayout);
export const CTAUrlFieldSchema = UrlFieldSchema.extend({
  name: z.literal('ctaUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

export const CTAImageFieldSchema = ImageFieldSchema.extend({
  name: z.literal('ctaImage'),
  role: z.literal(FieldRole.Image),
});

export const CTATextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('ctaText'),
  role: z.literal(FieldRole.CtaText),
});
export type CTATextField = z.infer<typeof CTATextFieldSchema>;

export const CTAPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

export const CTAHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

export const CTASubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

export const CTAFieldSchema = z.discriminatedUnion('name', [
  CTAImageFieldSchema,
  CTATextFieldSchema,
  CTAUrlFieldSchema,
  CTAPreheaderFieldSchema,
  CTAHeaderFieldSchema,
  CTASubheaderFieldSchema,
]);
export type CTAField = z.infer<typeof CTAFieldSchema>;

const CTAFieldGroupSchema = FieldGroupSchema.merge(
  z.object({
    fields: z.array(CTAFieldSchema),
  }),
);

export const CTAOptionsSchema = z.object({
  largeFormatEnabled: z.boolean().optional(),
  preheaderEnabled: z.boolean().optional(),
  subheaderEnabled: z.boolean().optional(),
  style: z
    .object({
      backgroundPosition: z.string().optional(),
      backgroundImage: z.string().optional(),
      backgroundColor: z.string().optional(),
    })
    .optional(),
  innerStyle: z
    .object({
      backgroundColor: z.string().optional(),
      borderRadius: z.string().optional(),
    })
    .optional(),
  colorScheme: ColorSchemeSchema.optional(),
  layout: CTALayoutSchema.optional(),
});
export type CTAOptions = z.infer<typeof CTAOptionsSchema>;

export const CTABlockConfigSchema = z.object({
  options: CTAOptionsSchema,
  type: z.literal(BlockType.Cta),
  fieldGroups: z.tuple([CTAFieldGroupSchema]),
  version: z.literal(2),
});

export type CTABlockConfig = z.infer<typeof CTABlockConfigSchema>;
